import axios from 'axios';
export const getCalendarList = (
  charge_user_id: number,
  start_date?: string | null,
  end_date?: string | null
) => {
  return axios
    .get(`/api/v1/calendar`, {
      params: {
        charge_user_id,
        start_date,
        end_date
      },
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
